import { render, staticRenderFns } from "./JingquPingjunKoubei.vue?vue&type=template&id=6daaf91e&scoped=true&"
import script from "./JingquPingjunKoubei.vue?vue&type=script&lang=js&"
export * from "./JingquPingjunKoubei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daaf91e",
  null
  
)

export default component.exports